<template>
  <va-card>
    <vue-element-loading :active="visible" :is-full-screen="true" />
    <div>
      <div class="row" style="padding-botom:0px!important;margin-bottom:0px!important">
        <div class="flex md9 sm12 xs6">
          <h4
            style="font-size: 29px !important;"
            class="text-uppercase"
          >
            {{commonName }}
          </h4>
          <h5 v-if="scientificName" style="font-style: italic !important">{{ scientificName }}</h5>
        </div>
        <div v-if="appUser.usertype==0" align="right" class="flex md3 sm12 xs6">
          <router-link :to="'/editrecords/' + this.id">
            <button
              type="button"
              class="btn btn-outline-secondary"
              style="
                padding-top: 0px !important;
                padding-bottom: 6px !important;
                padding-left: 20px !important;
                padding-right: 22px !important;
              "
            >
              <va-icon
                style="font-size:14px;!important;"
                name="fa fa-edit"
              />&nbsp;Edit
            </button>
          </router-link>
        </div>
      </div>

      <div class="row">
        <div  class="flex md4 sm12 xs12">
          <div v-if="photos.length>0"  v-viewer class="flex md3 sm12 xs12">
            <img
              :src="baseURL+photos[0].fileName"
              class="image"
              style="height: width:100%;height:auto;max-width:200px;object-fit:cover"
            />
          </div>

            <img
            v-else
              src="../../assets/noimage.png"
              class="image"
              style="width:250px;height:250px;max-width:250px;padding:20px;padding:0px!important;margin:0px!important;"
            />

        </div>

        <!-- <div class="flex md8 sm12 xs12">
          <h3 style="text-align: left">
            <b></b>
          </h3>
          <div class="row">
            <div class="flex xs6 md4">
              <p style="font-style: italic !important" v-if="scientificName">
                Scientific Name
              </p>
              <p v-if="classificationId">Classification</p>
              <p v-if="wlpaId">WLPA</p>
              <p v-if="citesId">CITES</p>
              <p v-if="conservationStatusId">IUCN</p>
              <p v-if="tradedParts">Traded Parts</p>
            </div>
            <div class="flex xs6 md6">
              <p class="text-capitalize" style="font-style: italics !important">
                <i>{{ this.scientificName }}</i>
              </p>
              <p class="text-capitalize">{{ this.classificationId }}</p>
              <p class="text-capitalize">{{ this.wlpaId }}</p>
              <p class="text-capitalize">{{ this.citesId }}</p>
              <p class="text-capitalize">{{ this.conservationStatusId }}</p>
              <p class="text-capitalize">{{ this.tradedParts }}</p>
            </div>
          </div>
        </div> -->

        <div style="justify-content: center;padding-top:30px!important;" class="col-md-8">
          <table class=" table-white flex md12">
            <thead>
              <tr></tr>
            </thead>
            <tbody class="row">

              <tr class="col-md-6"  v-if="classificationId">
                <!-- <th scope="col">Classification</th>   -->
                <td>{{ classificationId }}</td>
              </tr>
              <tr class="col-md-6 " v-if="citesId">
                <!-- <th scope="col">CITES</th> -->
                <td>{{ citesId }}</td>
              </tr>
              <tr class="col-md-6 pt-2" v-if="wlpaId">
                <!-- <th scope="col">WLPA</th> -->
                <td>{{ wlpaId }}</td>
              </tr>
              <tr class="col-md-6 pt-2" v-if="conservationStatusId">
                <!-- <th scope="col">IUCN</th> -->
                <td>{{conservationStatusId}}</td>
              </tr>
              <tr class="col-md-6 pt-2" v-if="typeId">
                <!-- <th scope="col">Species Type</th> -->
                <td>{{typeId }}</td>
              </tr>
              <tr class="col-md-6 pt-2" v-if="tradedParts">
                <!-- <th scope="col">Traded Parts</th> -->
                <td>{{tradedParts }}</td>
              </tr>

            </tbody>
          </table>
        </div>
      </div>
       <div v-if="distribution" style="width: 100%">
        <div class="card-header card-hd" style="color:white!important">Distributed Over</div>
        <div class="card-body text-secondary">
          <p style="text-align:justify;" v-html="distribution"></p>
        </div>
      </div>
       <div v-if="identification" style="width: 100%">
        <div class="card-header card-hd" style="color:white!important">Identification</div>
        <div class="card-body text-secondary">
          <p style="text-align:justify;" v-html="identification"></p>
        </div>
      </div>
            <div v-if="moreDetails" style="width: 100%">
        <div class="card-header card-hd" style="color:white!important">More Details</div>
        <div class="card-body text-secondary">
          <p style="text-align:justify;" v-html="moreDetails"></p>
        </div>
      </div>
          <div v-if="data.mapImage" style="width: 100%">
        <div class="card-header card-hd" style="color:white!important">Map Image Details</div>
        <div class="card-body text-secondary">
           <img
              :src="baseURL + data.mapImage"
              class="image"
              style="height: width:100%;height:auto;max-width:200px;object-fit:cover"
            />
          <p v-if="data.mapImage_copyright" style="text-align:justify;" >Copyright @{{data.mapImage_copyright}}</p>

        </div>
      </div>
      <div
        v-if="photos != null && photos.length > 1"
        class="card-header row card-hd mx-0 py-0  "
      >
        <div style="color: white" class="flex md9 sm12 xs6">Photos</div>
        <div v-if="appUser.usertype==0" align="right" class="flex md3 sm12 xs6">
          <router-link :to="'/editdigi/' + this.id">
            <button
              type="button"
              class="btn btn-outline-light"
              style="
                padding-top: 0px !important;
                padding-bottom: 6px !important;
                padding-left: 5px !important;
                padding-right: 7px !important;
              "
            >
              <va-icon
                style="font-size:14px;!important;"
                name="fa fa-edit"
              />&nbsp;Edit Images
            </button>
          </router-link>
        </div>
      </div>
      <div class="card-body text-secondary">
        <div
          v-if="photos != null && photos.length > 1"
          style="overflow-x: auto !important; overflow-y: hidden !important"
        >
          <div v-viewer style="display: flex">

            <div
              v-for="image in photos"
              :key="image._id"
              style="width:100%;min-height:250px; "
              class="col-md-3"
            >
            <b-row>
              <b-col cols="12">
 <img
                :src="baseURL+image.fileName"
                class="image"
                style="
                  width: 100%;
                  height: 150px;
                  object-fit: cover;
                  max-width: 250px;
                "

              />
              </b-col>
              <b-col cols="12" class="pt-0">
             <span style="font-size:15px" v-if="image.copyright">{{image.copyright}}</span>

              </b-col>
            </b-row>

            </div>
          </div>
        </div>
      </div>
    </div>
  </va-card>
</template>
<script>
import axios from 'axios'
import VueElementLoading from 'vue-element-loading'
export default {
  components: {
    VueElementLoading,
  },
  props: ['id'],
  data () {
    return {
      visible: false,
      imageURL: 'http://13.232.13.116/document/get/',
      photos: [],
      commonName: '',
      scientificName: '',

      family: '',
      description: '',
      wlpaId: '',
      citesId: '',
      conservationStatusId: '',
      classificationId: '',
      tradedParts: '',
      characteristics: [],
      data: [],
      typeId: null,
      moreDetails: null,
      identification: null,
      distribution: null,
    }
  },

  mounted: function () {
    this.getView()
  },
  computed: {
    appUser () {
      if (this.$store.state.userData) return this.$store.state.userData
      else return {}
    },
  },
  methods: {
    getView () {
      this.visible = true
      axios({
        method: 'POST',
        url: '/digitalguide/view/' + this.id,
        headers: {
          token: localStorage.getItem('token'),
        },
      })
        .then((response) => {
          if (response.data.status === true) {
            this.data = response.data.data
            this.commonName = response.data.data.commonName
            this.scientificName = response.data.data.scientificName
            this.classificationId = response.data.data.classificationId.cname
            this.citesId = response.data.data.citesId.name
            this.wlpaId = response.data.data.wlpaId.name
            this.typeId = response.data.data.typeId.tname
            this.tradedParts = response.data.data.tradedParts
            this.moreDetails = response.data.data.moreDetails
            this.distribution = response.data.data.distribution
            this.identification = response.data.data.identification
            this.conservationStatusId =
              response.data.data.conservationStatusId.csname
            // this.characteristics = response.data.data.characteristics
            // this.family = response.data.data.family
            // this.description = response.data.data.description
            // this.photos = response.data.data.photos;
            this.photos = response.data.data.photosDetails

            var arlen = []
            arlen = this.photos

            var temp = []
            for (var pic = 0; pic < arlen.length>0; pic++) {
              var ty = {
                src: this.baseURL + arlen[pic],
                thumb: this.baseURL + arlen[pic],
              }
              temp.push(ty)
            }
            this.images = temp

            this.visible = false
          } else if (response.data.status === false) {
            this.visible = false
          }
        })
        .catch((e) => {
          console.log(e)
          this.visible = false
          // this.errors.push(e)
          this.msg = 'failed'
        })
    },
  },
}
</script>
<style >

.bg-clr {
  background-color: #cf3939;
}
.card-hd {
  background-color: rgb(74, 79, 83) !important;
}
/* .card-header {
  padding: 0px !important;
} */
i {
  font-style: italic !important;
}
</style>
